import React from 'react'
import {Avatar, Col, Layout, Row, Space, Typography } from 'antd'
import {MenuOutlined} from '@ant-design/icons'
import { useGlobalContext } from '../../Contexts/GlobalContext'
import SearchBar from '../SearchBar'
import './style.less'
import { TOGGLE_MENU } from '../../Contexts/type'
import { Menu, Dropdown } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router'

const {Header} = Layout

function RenderMobileMenuBtn() {
    const {state, dispatch} =  useGlobalContext()
   
    function toggleMenu() {
        dispatch({
            type: TOGGLE_MENU,
            collapsed: !state.collapsed
        })
    }
    
    return (
        <div  
        onClick={() => toggleMenu()}
        style={{ 
            width: '30px', 
            height: '30px', 
            display:'flex', 
            justifyContent:'center', 
            alignItems: 'center'
        }} 
        >
        <MenuOutlined style={{ fill: 'black' }} />
    </div>
    )
}

function HeaderNav({ user }) {
    const router = useHistory();
    const menu =  ()=> {
      
        return (
        <Menu>
            <Menu.Item key="0">
            <a onClick={()=> {
                localStorage.removeItem('s_token');
                router.push('/');
                // alert(props)
            }}>Log out</a>
            </Menu.Item>
        </Menu>
        )
        };
    const { Text } = Typography
    return (
        <Header className='bit-header'>
            {/* <div> */}
            <Row align='middle' justify='space-between' gutter={{sm: 2}}>     
                {/* Mobile Menu */}
                <Col xs={3} sm={0} lg={0}>
                  <RenderMobileMenuBtn />
                </Col>

                <Col xs={18} sm={16} lg={12}>
                <SearchBar />    
                </Col>
                <Col xs={3}  sm={4}  lg={12} style={{ display: 'flex', justifyContent: 'flex-end' }} >
                    <Space size='small'>
                     
                        <Dropdown overlay={menu} trigger={['click']}>
                          
                      
                            <a className="ant-dropdown-link" onClick={e => e.preventDefault()}>
                            <Avatar name={user && user.user && user.user.firstName} src='data:image/png;base64,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'/>
                            <Text size='small'> {user && user.user && user.user.firstName} {user && user.user && user.user.lastName}  </Text>
                            <DownOutlined />
                            </a>
                        
                        </Dropdown>

                      
                    </Space>
                </Col>
            </Row>

            {/* </div> */}
        </Header>
    )
}

export default HeaderNav




// const menu =  ()=> {
//     const router = useHistory();
//     return (
//     <Menu>
//         <Menu.Item key="0">
//         <a onClick={()=> {
//             localStorage.removeItem('s_token');
//             router.push('/');
//             // alert(props)
//         }}>1st menu item</a>
//         </Menu.Item>
//     </Menu>
//     )
//     };


